/**
 * Substitutes $slug variable in URL string with the current post slug
 * @param urlString - URL string potentially containing $slug variable
 * @param currentPathname - Current pathname to extract slug from (optional, defaults to window.location.pathname)
 * @returns Processed URL string, or null if $slug cannot be resolved
 */
export const substitutePostSlugInUrl = (urlString: string, currentPathname?: string): string | null => {
  if (!urlString.includes('$slug')) {
    return urlString;
  }

  const pathname = currentPathname || (typeof window !== 'undefined' ? window.location.pathname : '');

  // Check if we're on a post page (/p/slug)
  if (pathname.startsWith('/p/')) {
    const currentSlug = pathname.split('/p/')[1]?.split('?')[0];
    if (currentSlug) {
      return urlString.replace(/\$slug/g, currentSlug);
    }
  }

  // Cannot resolve $slug - return null to indicate this step should be skipped
  return null;
};
